export default __webpack_public_path__ + "static/media/AnnotateVideos.13e254a3.svg";